import * as React from "react";
import { Component } from "react";

import { MenuItem, MenuItemProps } from "react-toolbox/lib/menu";

const MenuTheme = require("../../themes/menu.scss");

export interface StyledMenuItemProps extends MenuItemProps {
    to?: string;
}

interface StyledMenuItemState {

}

class StyledMenuItem extends Component<StyledMenuItemProps, StyledMenuItemState> {

    render() {
        const { theme, ...others } = this.props;

        const useTheme = { ...MenuTheme, ...theme };

        return (
            <MenuItem
                theme={useTheme}
                {...others}>
                {this.props.children}
            </MenuItem>
        );
    }
}

export { StyledMenuItem as MenuItem };
export default StyledMenuItem;
